// Copyright © Paladin Projects LLC, 2026

import { FC, useState, ReactNode, useLayoutEffect } from "react";
import { IAdaptivityContextValue, AdaptivityContext, TWindowWidth } from "./adaptivityContext";

interface IProps {
  children: ReactNode
}

const getBreakpoint = (width: number): TWindowWidth => {
  if (width <= 576) return 'smallMobile';
  // if (width <= 768) return 'mobile';
  // if (width <= 992) return 'tabletPortrait';
  // if (width <= 1200) return 'tabletAlbum';
  return 'desktop';
};

export const AdaptivityContextProvider: FC<IProps> = ({ children }) => {
  const [ breakpoint, setBreakpoint ] = useState<TWindowWidth>(getBreakpoint(window.innerWidth));
  const [ windowWidth, setWindowWidth ] = useState<number>(() => window.innerWidth);

  useLayoutEffect(() => {
    const handleResize = () => {
      const innerWidth = window.innerWidth;
      setWindowWidth(innerWidth);
      setBreakpoint(getBreakpoint(innerWidth));
    };

    handleResize();
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const value: IAdaptivityContextValue = {
    windowWidth,
    breakpoint
  };

  return (
    <AdaptivityContext.Provider value={value}>
      {children}
    </AdaptivityContext.Provider>
  );
};
